import React from 'react';
import { getDynamicInlineStyleMapper, RICOS_TEXT_COLOR_TYPE, RICOS_TEXT_HIGHLIGHT_TYPE, RICOS_FONT_SIZE_TYPE } from 'wix-rich-content-common';

const textColorInlineStyleMapper = getDynamicInlineStyleMapper(RICOS_TEXT_COLOR_TYPE);
const textHighlightInlineStyleMapper = getDynamicInlineStyleMapper(RICOS_TEXT_HIGHLIGHT_TYPE);
const fontSizeInlineStyleMapper = getDynamicInlineStyleMapper(RICOS_FONT_SIZE_TYPE);
const staticInlineStyleMapper = (mergedStyles) => ({
  BOLD: (children, { key }) => /* @__PURE__ */ React.createElement("strong", { key }, children),
  ITALIC: (children, { key }) => /* @__PURE__ */ React.createElement("em", { key }, children),
  UNDERLINE: (children, { key }) => /* @__PURE__ */ React.createElement("u", { key, className: mergedStyles.underline }, children),
  CODE: (children, { key }) => /* @__PURE__ */ React.createElement("span", { key, className: mergedStyles.code }, children),
  NOT_BOLD: (children, { key }) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: "normal" }, key }, children),
  NOT_ITALIC: (children, { key }) => /* @__PURE__ */ React.createElement("span", { style: { fontStyle: "normal" }, key }, children)
});
const getViewerInlineStyleMappers = (contentState, config) => [
  staticInlineStyleMapper,
  fontSizeInlineStyleMapper({}, contentState),
  textColorInlineStyleMapper(config, contentState),
  textHighlightInlineStyleMapper(config, contentState)
];

export { getViewerInlineStyleMappers };
//# sourceMappingURL=inlineStyleMapper.js.map
